var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9243 18.4745C9.58675 18.8126 9.12868 19.0026 8.65093 19.0029C8.17318 19.0032 7.71491 18.8135 7.377 18.4758L3.52384 14.6247C3.18594 14.287 2.99609 13.8288 2.99609 13.3511C2.99609 12.8733 3.18594 12.4152 3.52384 12.0774L10.0215 5.58272C10.3968 5.20771 10.9055 4.99707 11.436 4.99707H15.0011C16.1061 4.99707 17.0019 5.89287 17.0019 6.9979V10.5579C17.0019 11.088 16.7915 11.5964 16.417 11.9716L9.9243 18.4745Z",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0035 7.99829V11.7973C21.0035 12.3279 20.7927 12.8368 20.4175 13.2121L14.7529 18.8767",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponTag);
export default __webpack_public_path__ + "static/media/couponTag.fff6416a6dc9591567ef80e253b4674f.svg";
export { ForwardRef as ReactComponent };